import { render, staticRenderFns } from "./ChooseGroupItem.vue?vue&type=template&id=023901ba&"
import script from "./ChooseGroupItem.vue?vue&type=script&lang=ts&"
export * from "./ChooseGroupItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports